<template>
	<div :id="toh.EventID" :data-playlist-id="toh.PlaylistID" class="top-of-the-hour">
		<v-card variant="outlined" rounded="0" height="50" :class="{'switching-days': isMiddleNight}"
			class="d-flex align-center">
			<v-row no-gutters style="font-weight: bold;">
				<v-col cols="2" class="d-flex text-body-1">
					<div class="event-field font-weight-bold"
						:class="{'text-larger padding-left': isMiddleNight, 'pl-13': !isMiddleNight}">
						{{ hour }}
					</div>
				</v-col>
				<v-col cols="4" class="d-flex text-body-1 padding-left-icon" :class="{'text-larger': isMiddleNight}">
					<div class="d-flex">
						<v-icon class="asset-type-icon" :color="!darkMode ? 'rgb(60,60,60)' : '#fff'">
							{{ "mdi-clock" }}
						</v-icon>
						<span class="event-field tex t-truncate ml-4 mr-4 font-weight-bold">
                            TOP OF HOUR
                        </span>
					</div>
				</v-col>
				<v-col cols="6" class="event-field text-body-1 font-weight-bold"
					:class="{'text-larger': isMiddleNight}">
					{{ date }}
				</v-col>
			</v-row>
		</v-card>
	</div>
</template>

<script>
import moment from "moment-timezone";

export default {
	name: "PlaylistTopOfTheHour",

	props: ["toh", "selectedStation"],

	computed: {
		hour() {
			return moment.tz(this.toh.AirStartDateTime, this.selectedStation.StationTimeZone).format("HH:mm:ss");
		},

		date() {
			return moment.tz(this.toh.AirStartDateTime, this.selectedStation.StationTimeZone)
						 .format("MMMM D, YYYY, HH:mm:ss");
		},

		isMiddleNight() {
			return this.hour === "00:00:00";
		},

		darkMode() {
			return this.$store.getters.darkMode();
		},
	}
};
</script>

<style lang="scss" scoped>
.v-card {
	background: rgba(230, 234, 237, .45);
	border: none;

	.row {
		height: inherit;
	}

	.projected-time {
		color: $ihm-orange1;
	}

	.switching-days {
		background: rgb(195, 107, 107, 1);
		-webkit-background-clip: text;
		color: transparent;
		font: 900 2vmin/7vh cookie, cursive;
		text-align: center;
	}

	.text-larger {
		display: flex;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		font-weight: 700 !important;
		font-size: 1.8vh !important;
	}

	.padding-left {
		padding-left: 52px;
	}

	.padding-left-icon {
		padding-left: 13px;
	}
}
</style>
